import React, { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  MuiTitle,
  Media,
  MediaLeft,
  MediaContent,
} from 'src/ui/mui-ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import propTypes from 'prop-types';
import classNames from 'classnames';

export function GuidelinesCard({ guidelines }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const icon = isCollapsed ? 'question-circle' : 'times-circle';

  return (
    <Card
      className={classNames('guidelines-card', { 'is-collapsed': isCollapsed })}
    >
      <CardContent>
        <Button
          isColor="text"
          onClick={() => setIsCollapsed(!isCollapsed)}
          hasTextColor="info"
        >
          <span className="icon">
            <FontAwesomeIcon icon={['fal', icon]} />
          </span>
        </Button>
        <MuiTitle isSize="5" hasTextColor="primary">
          Guidelines
        </MuiTitle>
        <ul className="guidelines-list">
          {guidelines.map(guideline => (
            <Media tag="li" key={guideline}>
              <MediaLeft>
                <span className="icon is-medium has-text-grey-lighter circle">
                  <FontAwesomeIcon icon={['fal', 'circle']} />
                </span>
                <span className="icon is-medium has-text-info check">
                  <FontAwesomeIcon icon={['fal', 'check']} />
                </span>
              </MediaLeft>
              <MediaContent>
                <p className="is-size-7 has-text-grey-medium-dark">
                  {guideline}
                </p>
              </MediaContent>
            </Media>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}

GuidelinesCard.propTypes = {
  guidelines: propTypes.arrayOf(propTypes.string).isRequired,
};
